import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import AuctionPage from 'containers/Auctions/Auction';
import CVLandingPage from 'containers/CVLandingPage';
import CalendarPage from 'containers/CalendarPage';
import ViewDrawing from 'containers/Drawings/ViewDrawing';
import FadeSwitch from 'containers/FadeSwitch';
import FaqPage from 'containers/FaqPage';
import ForgotPasswordPage from 'containers/ForgotPasswordPage';
import GameFinderPage from 'containers/GameFinderPage';
import GamePage from 'containers/GamePage';
import HomePage from 'containers/HomePage';
import HotelBookingPage from 'containers/HotelBookingPage';
import LoginPage from 'containers/LoginPage';
import LogoutPage from 'containers/LogoutPage';
import DoubleDrive from 'containers/Microsites/DoubleDrive';
import OktaLoginPage from 'containers/OktaLogin/OktaLoginPage/Loadable';
import PrivacyPolicyPage from 'containers/PrivacyPolicyPage';
import PrivateRoute from 'containers/PrivateRoute';
import PrizeCodeRedemptionPage from 'containers/PrizeCodeRedemptionPage';
import ProfileDetailsPage from 'containers/ProfileDetailsPage';
import PromoPerksPage from 'containers/PromoPerksPage';
import PromotionLandingPage from 'containers/PromotionLandingPage';
import ResetPasswordPage from 'containers/ResetPasswordPage';
import ResponsibleGamingPage from 'containers/ResponsibleGamingPage';
import RewardsPage from 'containers/RewardsPage';
import SignUpContainerPage from 'containers/SignUpContainerPage';
import SupportPage from 'containers/SupportPage';
import TermsOfServicePage from 'containers/TermsOfServicePage';
import TermsOfServiceUpdatedPage from 'containers/TermsOfServiceUpdatedPage';
import TournamentPage from 'containers/TournamentPage';
import VaultPage from 'containers/VaultPage';
import VerifyChangeEmailPage from 'containers/VerifyChangeEmailPage';
import VerifyNewUserPage from 'containers/VerifyNewUserPage';
import WhatsNewPage from 'containers/WhatsNewPage';

const TRANSITION_PROPS = { timeout: 250, classNames: 'fade' };

function DesktopWebRoutes({
  authenticated,
  location,
  onTransitionStart,
  onTransitionInterval
}) {
  return (
    <FadeSwitch
      location={location}
      transitionProps={TRANSITION_PROPS}
      onTransitionStart={onTransitionStart}
      onTransitionInterval={onTransitionInterval}
    >
      <Route exact path="/logout" component={LogoutPage} />
      <Route exact path="/resetPassword/:token" component={ResetPasswordPage} />
      <Route
        exact
        path="/verifyChangeEmail/:token"
        component={VerifyChangeEmailPage}
      />
      <Redirect exact from="/view-terms-of-service" to="/terms" />
      <Redirect exact from="/terms-of-service" to="/terms" />
      <Route exact path="/terms" component={TermsOfServicePage} />
      <Redirect exact from="/privacy-policy" to="/privacy" />
      <Route path="/privacy" component={PrivacyPolicyPage} />
      <Route path="/faq" component={FaqPage} />
      <Route path="/responsible-gaming" component={ResponsibleGamingPage} />
      <Route path="/whats-new" component={WhatsNewPage} />
      <Route path="/support" component={SupportPage} />
      <Route
        path="/promotions/:property/:slug"
        component={PromotionLandingPage}
      />
      <Route path="/double-drive" component={DoubleDrive} />

      <PrivateRoute
        authState={false}
        path="/login"
        exact
        component={LoginPage}
      />
      <PrivateRoute authState={false} path="/okta" component={OktaLoginPage} />
      <PrivateRoute
        authState={false}
        path="/signup"
        exact
        component={SignUpContainerPage}
      />
      <PrivateRoute
        authState={false}
        path="/verifyNewUser/:token"
        exact
        component={VerifyNewUserPage}
      />
      <PrivateRoute
        authState={false}
        exact
        path="/forgot-password"
        component={ForgotPasswordPage}
      />

      <PrivateRoute
        exact
        path="/terms-of-service-updated"
        component={TermsOfServiceUpdatedPage}
      />
      <PrivateRoute path="/game/:game" exact component={GamePage} />
      <PrivateRoute
        path="/tournament/:tournament"
        keyParam="tournament"
        exact
        component={TournamentPage}
      />
      <PrivateRoute path="/rewards" component={RewardsPage} />
      <PrivateRoute path="/vault" component={VaultPage} />
      <PrivateRoute path="/profile" component={ProfileDetailsPage} />
      <PrivateRoute path="/game-finder" component={GameFinderPage} />
      <PrivateRoute path="/hotel-booking" component={HotelBookingPage} />
      <Redirect from="/hotel" to="/hotel-booking" />
      <PrivateRoute path="/calendar" component={CalendarPage} />
      <PrivateRoute
        path="/auctions/:id"
        keyParam="id"
        exact
        component={AuctionPage}
      />
      <PrivateRoute
        path="/drawings/:id"
        keyParam="id"
        exact
        component={ViewDrawing}
      />
      <PrivateRoute
        path="/prizecoderedemption"
        component={PrizeCodeRedemptionPage}
      />
      <PrivateRoute path="/promo-perks" component={PromoPerksPage} />

      {/* HomePage must be last route in Firewall section. */}
      {authenticated && (
        <PrivateRoute key="HomePage" path="*" exact component={HomePage} />
      )}
      {/* Show LandingPage at "/" path when not logged in. */}
      {!authenticated && (
        <Route key="LandingPage" path="/" exact component={CVLandingPage} />
      )}
      <Redirect to="/" key="not-found-redirect" />
    </FadeSwitch>
  );
}

export default DesktopWebRoutes;
